import {qspost} from '@/plugins/axios'

/*
 * 物业情况列表
 * @constructor jack
 * */
export const wuYeQingKuangList = (searchXiangMuId, searchSheQuId, searchLouId, searchMenId, searchHuId, searchNianDu, searchShouFeiXiangMu, page, pageSize) => qspost('/Index/Wuyeqingkuang/wuYeQingKuangList', {
  searchXiangMuId,
  searchSheQuId,
  searchLouId,
  searchMenId,
  searchHuId,
  searchNianDu,
  searchShouFeiXiangMu,
  page,
  pageSize
})


/*
 * 物业情况更新
 * @constructor jack
 * */
export const wuYeQingKuangUpdate = (roomId, nian, YJWuYeFei, SjWuYeFei, YJBaoAnFei, SjBaoAnFei, YJWeiShengFei, SjweishengFei, YJTingCheGuanLiFei, SjTingCheGuanLiFei, YJLaJiQingYunFei, SjLaJiQingYunFei, otherDeiYong) => qspost('/Index/Wuyeqingkuang/wuYeQingKuangUpdate', {
  roomId,
  nian,
  YJWuYeFei,
  SjWuYeFei,
  YJBaoAnFei,
  SjBaoAnFei,
  YJWeiShengFei,
  SjweishengFei,
  YJTingCheGuanLiFei,
  SjTingCheGuanLiFei,
  YJLaJiQingYunFei,
  SjLaJiQingYunFei,
  otherDeiYong
})

/*
 * 物业情况详情
 * @constructor jack
 * */
export const wuYeQingKuangShow = (roomId,nian) => qspost('/Index/Wuyeqingkuang/wuYeQingKuangShow', {roomId,nian})



/*
 * 历年物业缴费情况列表
 * @constructor jack
 * */
export const liNianWuYeQingKuangList = (roomId) => qspost('/Index/Wuyeqingkuang/liNianWuYeQingKuangList', {roomId})


/*
 * 报修情况列表
 * @constructor jack
 * */
export const getBaoXiuList = (xiangMuId, xiaoQuId, adminId, state, type, searchTime, startTime, endTime, page, pageSize) => qspost('/Index/Xinxuqiu/getBaoXiuList', {
  xiangMuId,
  xiaoQuId,
  adminId,
  state,
  type,
  searchTime,
  startTime,
  endTime,
  page,
  pageSize
})

/*
 * 报修情况统计
 * @constructor jack
 * */
export const getBaoXiuShuJu = (xiangMuId, xiaoQuId, adminId, state, type, searchTime, startTime, endTime) => qspost('/Index/Xinxuqiu/getBaoXiuShuJu', {
  xiangMuId,
  xiaoQuId,
  adminId,
  state,
  type,
  searchTime,
  startTime,
  endTime
})

/*
 * 报修情况状态修改
 * @constructor jack
 * */
export const changeBaoXiuStatus = (id,state) => qspost('/Index/Xinxuqiu/changeBaoXiuStatus', {id,state})


/*
 * 报修情况删除
 * @constructor jack
 * */
export const delBaoXiu = (id) => qspost('/Index/Xinxuqiu/delBaoXiu', {id})
